import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { TeamsSyncResultsDialogComponent } from 'src/app/components/teams-sync-results-dialog/teams-sync-results-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';

interface TeamsMeetingItem {
  id: string;
  title: string;
  start: string;
  organizer?: string;
}

@Component({
  selector: 'app-teams-sync-page',
  templateUrl: './teams-sync-page.component.html',
  styleUrls: ['./teams-sync-page.component.css']
})
export class TeamsSyncPageComponent implements AfterViewInit {
  meetings: TeamsMeetingItem[] = [
    { id: 't1', title: 'Sprint Planning', start: 'Mon, 10:00 AM', organizer: 'Alice' },
    { id: 't2', title: 'Design Review', start: 'Tue, 2:30 PM', organizer: 'Bob' },
    { id: 't3', title: 'Weekly Sync', start: 'Fri, 4:00 PM', organizer: 'Team' },
    { id: 't4', title: 'Architecture Talk', start: 'Wed, 11:00 AM', organizer: 'Carol' },
    { id: 't5', title: 'Customer Demo', start: 'Thu, 3:00 PM', organizer: 'Eve' },
    { id: 't6', title: 'Retrospective', start: 'Fri, 5:00 PM', organizer: 'Team' },
  ];

  displayedColumns: string[] = ['title', 'start', 'organizer', 'actions'];
  dataSource = new MatTableDataSource<TeamsMeetingItem>(this.meetings);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private http: HttpClient,private meetingService:MeetingService, private dialog: MatDialog) {}

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  onSync(item: TeamsMeetingItem) {
    // For now, just log the meeting details
    console.log('Teams Sync clicked for:', item);
    var meetingDetails = {
      meetingTitle : "instant meeting",
      meetingUTCDate : "2026-01-07T00:00:00.0000000",
    }
    this.meetingService.searchMeeting(meetingDetails).subscribe((resp:any)=>{
      console.log("data : ", resp);
      // const apiList = resp?.body ?? resp ?? [];
      // const mapped: Array<{_id:number; meetingDate:string; meetingTitle:string}> = (apiList || []).map((m:any)=>({
      //   _id: Number(m._id ?? m.id ?? m.meetingId ?? 0),
      //   meetingDate: String(m.meetingDate ?? m.start ?? ''),
      //   meetingTitle: String(m.meetingTitle ?? m.title ?? 'Untitled')
      // }));

      const candidates = null;

      // const candidates = [
      //   { _id: 1, meetingDate: '2024-04-29T00:00:00.000+00:00', meetingTitle: 'Instant Meeting jgdfg' },
      //   { _id: 41968, meetingDate: '2022-01-24T00:00:00.000+00:00', meetingTitle: 'Instant Meeting' }
      // ];


      this.dialog.open(TeamsSyncResultsDialogComponent, {
        width: '640px',
        maxWidth: '95vw',
        data: { sourceMeeting: item, candidates: candidates }
      });
    }, (err:any)=>{
      console.error('searchMeeting error', err);
      const SampleData = [
        { _id: 1, meetingDate: '2024-04-29T00:00:00.000+00:00', meetingTitle: 'Instant Meeting jgdfg' },
        { _id: 41968, meetingDate: '2022-01-24T00:00:00.000+00:00', meetingTitle: 'Instant Meeting' }
      ];
      this.dialog.open(TeamsSyncResultsDialogComponent, {
        width: '640px',
        maxWidth: '95vw',
        data: { sourceMeeting: item, candidates: SampleData }
      });
    })

  }

  // Called when date range changes from the UI
  dateRangeChange(startInput: HTMLInputElement, endInput: HTMLInputElement) {
    const startDate = startInput?.value ? new Date(startInput.value) : null;
    const endDate = endInput?.value ? new Date(endInput.value) : null;
    if (!startDate || !endDate) {
      return;
    }

    const startUtc = this.toUtcStartOfDayString(startDate);
    const endUtc = this.toUtcEndOfDayString(endDate);
    // const userId = localStorage.getItem('userId') || '147';
    const userId = '147';


    const baseUrl = 'https://192.168.193.65:8083/authservice1/api/meetings';
    const params = new HttpParams()
      .set('userId', userId)
      .set('startDate', startUtc)
      .set('endDate', endUtc);

      this.meetingService.fetchTeamsMeeting(startUtc+'&'+endUtc).subscribe((data:any)=>{
        console.log(data);
      })

    // this.http.get<any[]>(baseUrl, { params }).subscribe({
    //   next: (list) => {
    //     // Map incoming list to table items; adjust keys if your API differs
    //     const mapped: TeamsMeetingItem[] = (list || []).map((m: any) => ({
    //       id: String(m.id ?? m.meetingId ?? ''),
    //       title: m.title ?? m.meetingTitle ?? 'Untitled',
    //       start: m.start ?? m.meetingStartTime ?? '',
    //       organizer: m.organizer ?? m.host ?? ''
    //     }));
    //     this.meetings = mapped;
    //     this.dataSource.data = mapped;
    //   },
    //   error: (err) => {
    //     console.error('Failed to load Teams meetings:', err);
    //     this.meetings = [];
    //     this.dataSource.data = [];
    //   }
    // });
  }

  private toUtcStartOfDayString(d: Date): string {
    const y = d.getUTCFullYear();
    const m = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = d.getUTCDate().toString().padStart(2, '0');
    return `${y}-${m}-${day}T00:00:00`;
  }

  private toUtcEndOfDayString(d: Date): string {
    const y = d.getUTCFullYear();
    const m = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = d.getUTCDate().toString().padStart(2, '0');
    return `${y}-${m}-${day}T23:59:59`;
  }
}
